import { connect } from 'react-redux';
import { History } from './History';
import { getDynamicsConfig, getHost, getI18n } from 'src/redux/core/coreSelectors';
import { getAllCurrentCaseHistoryFilters, getCurrentCaseApplicants, getCurrentCaseHistory, getCurrentCaseHistoryFilters, } from 'src/redux/cases/casesSelectors';
import { casesActions } from 'src/redux/cases/casesActions';
var mapStateToProps = function (state) { return ({
    i18n: getI18n(state),
    applicants: getCurrentCaseApplicants(state),
    history: getCurrentCaseHistory(state),
    allFiltersHistory: getAllCurrentCaseHistoryFilters(state),
    currentFiltersHistory: getCurrentCaseHistoryFilters(state),
    dynamicsConfig: getDynamicsConfig(state),
    host: getHost(state),
}); };
var mapDispatchToProps = function (dispatch) { return ({
    updateHistoryFilters: function (historyFilters) {
        return dispatch(casesActions.updateHistoryFilters(historyFilters));
    },
    resetHistoryFilters: function () { return dispatch(casesActions.resetHistoryFilters()); },
}); };
export default connect(mapStateToProps, mapDispatchToProps)(History);
